export const GENERATE_REPORTS_TRUST_ACCOUNTS = 'generate_reports_trust_account';
export const GENERATE_REPORTS_TRUST_CANCELLED_CONTRACTS =
  'generate_reports_trust_cancelled_contracts';
export const GENERATE_REPORTS_TRUST_CLOSED_CONTRACTS = 'generate_reports_trust_closed_contracts';
export const GENERATE_REPORTS_TRUST_DEFAULT_CONTRACTS = 'generate_reports_trust_default_contracts';

export const TRUST_DESIGNATED_BENIFICIARY = 'Designated Beneficiary';
export const TRUST_PURCHASER = 'Purchaser';
export const TRUST_BENIFICIARY = 'Beneficiary';

export const TRUST_CONTRACT_TYPE_TA = 'TA';
export const TRUST_CONTRACT_TYPE_DTC = 'DTC';
export const TRUST_CONTRACT_TYPE_CTC = 'CTC';
export const TRUST_CONTRACT_TYPE_ECC = 'ECC';

export const TRUST_AGREEMENT_LOCATION_ITEM = 'AgreementLocationItem';
export const TRUST_AGREEMENT_MEMORIAL_ITEM = 'AgreementMemorialItem';
export const TRUST_AGREEMENT_COLLECTION_ITEM = 'AgreementCollectionItem';
export const TRUST_AGREEMENT_PROPERTY = 'AgreementProperty';
export const TRUST_AGREEMENT_STATUS_CANCELLED = 'Cancelled';
